export default "__VITE_ASSET__l9e7Mu4E__"